import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TdoeButtonComponent, TdoeButtonDirective } from '@tdoe/design-system';

@Component({
  selector: 'app-export-limit-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    TdoeButtonDirective
  ],
  templateUrl: './export-limit-modal.component.html',
  styleUrl: './export-limit-modal.component.scss'
})
export class ExportLimitModalComponent {

  public readonly dialogData: number = inject(MAT_DIALOG_DATA);
  public readonly dialogRef = inject(MatDialogRef<any>);



}
